var StorefrontAPI = StorefrontAPI || {};
StorefrontAPI.Query = async (query = '') =>  {
  const response = await fetch('https://weatherstrong.myshopify.com/api/2024-07/graphql.json', {
      method: 'POST',
      mode: "cors",
      headers: {
          "X-Shopify-Storefront-Access-Token": '749985dd2bf021822d62fd75479058f6',
          'Content-Type': 'application/graphql'
      },
      body: query
  });
  return response.json();
};
